







import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { MswAppTitle } from '@/shared/msw-app-title';

@Component({
  components: {
    MswAppTitle,
  },
})

export default class MswTraining extends SwExtendedVue{
  source: any = '';
  sessionId: any = '';
  getIframeSource() {
    const host = location.origin;
    this.sessionId = JSON.parse(this.$store.getters.getUserInfo).user.sessionId;
    this.sessionId = btoa(this.sessionId);
    this.source = `${host}/aspnet/Training/TrainingManagement.aspx?mode=APP&I=${this.sessionId}`;
  }
  mounted() {
    this.getIframeSource();
  }
}
